module.exports = __webpack_public_path__ + "media/newstyle/images/icon-rakuten-92aca3b6129663ba56c007d136d401ea.svg";